var _path, _rect, _line, _line2, _line3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgContactIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.83765 5.61719C4.31567 5.85296 0.756836 8.36434 0.756836 11.4277C0.756836 13.7528 2.80706 15.7599 5.77251 16.6953V17.4774V19.1991L7.27251 18.3539L8.83765 17.4721V15.7504L8.49067 15.9459L7.27251 16.6322V15.5957L6.22377 15.2648C3.52596 14.4138 2.25684 12.7888 2.25684 11.4277C2.25684 10.4785 2.83643 9.43305 4.15746 8.55584C5.32527 7.78037 6.95926 7.22983 8.83765 7.11945V5.61719Z",
    fill: "#122C44"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11.5381,
    y: 0.749023,
    width: 12.7111,
    height: 22.5,
    rx: 2.25,
    stroke: "#122C44",
    strokeWidth: 1.5
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 7.56738,
    y1: 11.249,
    x2: 8.08759,
    y2: 11.249,
    stroke: "#122C44",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 16.6582,
    y1: 20.249,
    x2: 19.1986,
    y2: 20.249,
    stroke: "#122C44",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 4.53711,
    y1: 11.249,
    x2: 5.05731,
    y2: 11.249,
    stroke: "#122C44",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactIcon);
export default __webpack_public_path__ + "static/media/contactIcon.fd3064b6165281e249b04126189c52d2.svg";
export { ForwardRef as ReactComponent };